import createVueComponent from '../createVueComponent';

const ChevronsDownUp = createVueComponent('ChevronsDownUpIcon', [
  ['path', { d: 'm7 20 5-5 5 5', key: '13a0gw' }],
  ['path', { d: 'm7 4 5 5 5-5', key: '1kwcof' }],
]);

export default ChevronsDownUp;
